import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Box, Typography, Button, Avatar } from '@mui/material';
import logo from "../components/Logo/Colloquia_Logo.png";
import Tooltip from '@mui/material/Tooltip';
import { useLocation, useHistory } from 'react-router-dom'; 

function Page1SubPageA() {
    // declare a state variable 'topPosts' initialized to an empty array to store the top 3 posts
    // declare a fxn 'setTopPosts' to update that state
    const [topPosts, setTopPosts] = useState([]);

    // for view comment button that shows a popular post and its comments on a separate page
    const history = useHistory();
    const location = useLocation();

    const [popularMode, setPopularMode] = useState("voting-power");
    const [loadingPosts, setLoadingPosts] = useState(false);
    const [aiError, setAiError] = useState(null);

    /*
    // fetch top posts from server; runs once component is mounted
    useEffect(() => {
        // send GET request to backend endpoint '/posts/top'; returns top 3 most upvoted posts
        axios.get('/posts/top')
            // if request is successful, store response data (array of posts) in state
            .then((res) => setTopPosts(res.data))
            // if request fails, log error
            .catch((err) => console.error("Failed to load top posts", err));
    }, []);
    */
   useEffect(() => {
        let cancelled = false;

        const fetchPopularPosts = async () => {
            try {
                setLoadingPosts(true);
                setAiError(null);

                const res = await axios.get("/posts/top", {
                    params: {
                        mode: popularMode,
                    },
                });

                if (!cancelled) {
                    setTopPosts(res.data);
                }
            } catch (err) {
                console.error(
                    "Failed to load popular posts",
                    err
                );

                if (!cancelled) {
                    setTopPosts([]);

                    if (popularMode === "ai") {
                        setAiError(
                            "AI Popular is temporarily unavailable. Please try again shortly."
                        );
                    }
                }
            } finally {
                if (!cancelled) {
                    setLoadingPosts(false);
                }
            }
        };

        fetchPopularPosts();

        return () => {
            cancelled = true;
        };
    }, [popularMode]);

    // fxn called when user clicks upvote button
    // postId: MongoDB _id of the post being unvoted
    // sends POST /post/:id/upvote to server
    // receives { upvotes, voted } in response
    // patches React state so UI shows the new count and color
    const toggleVote = async (postId) => {
        try {
             // hit backend endpoint that toggles a vote
             const res = await axios.post(`/post/${postId}/upvote`);

             // update <posts> in react state so ui rerenders
             // setPosts(prev => ...) receives the previous array of posts and must return a new array
             // prev.map( p => { ... } ) 
                // iterate through every post p in old array
                // if p is the one user just voted on, return a new object with the fresh upvote info from server
                // otherwise, return p unchanged
            setTopPosts((prev) =>
                prev.map((p) =>
                    p._id === postId
                        ? {
                            ...p, // copy exisiting post fields
                            upvotes: res.data.upvotes, // updated count
                            voted:   res.data.voted // true or false that user voted
                        }
                        : p // all other posts unchanged
                )
            );

        } catch(err) {
            console.error("Vote error", err);
        }
    };

    // async fxn to handle adding a comment
    // takes target post's id and comment text as parameters
    const handleAddComment = async (postId, text) => {
        // if text is empty or white space, do nothing (early return)
        if (!text || text.trim() === "") return;

        try {
            // send post request to the backend to add the comment
            // pass comment text in request body
            const res = await axios.post(`/post/${postId}/comment`, { text });

            // update topPosts to reflect new comment
            // iterate through current list of posts
            setTopPosts(prev =>
                prev.map(p =>
                    // if current post is the one we just commented on
                    p._id === postId
                        ? {
                            ...p, // copy exisiting post properties
                            comments: res.data, // update comments array with fresh data from server
                            newComment: "" // reset new comment input field
                        }
                        : p // for all other posts, return them unchanged
                )
            );
        } catch(err) {
            console.error("Comment failed", err);
        }
    };

    // fxn called when user hits "Join Video Call" button for each post on popular page
    const joinVideoCall = async (postId) => {
        try {
            // send POST request to backend endpoint '/post/:id/video-room' to either create or retrieve a video room for current post
            const res = await axios.post(`/post/${postId}/video-room`);

            // extract video room call url from server response 
            const roomUrl = res.data.url;

            // open video room call url in new browser tab or window
            window.open(roomUrl, "_blank");
        } catch(err) {
            console.error("Failed to join video call", err);
            alert("Could not join video call.");
        }
    };

    const visitProfile = (e, userId) => {
        e.stopPropagation(); // prevent opening the post
        history.push(`/user/view/${userId}`);
    };

    const navItems = [
      { label: "Popular", path: "/mainsocial/popular" },
      { label: "Following", path: "/mainsocial/following" },
      { label: "Academia", path: "/mainsocial/academia/popular" },
      { label: "Topic Threads", path: "/mainsocial/topicthreads" },
      { label: "Photos", path: "/mainsocial/photos/following" },
      { label: "Videos", path: "/mainsocial/videos/following" }
    ];

    const getButtonStyles = (path) => {
      const active = location.pathname === path;

      return {
        padding: "6px 12px",
        borderColor: active ? "#1f1f1f" : "#333333",
        color: active ? "#1f1f1f" : "#333333",
        backgroundColor: active ? "rgba(0,0,0,0.08)" : "transparent",
        fontWeight: active ? 600 : 500,
        transition: "all 0.15s ease",
        "&:hover": {
          borderColor: "black",
          color: "black",
          backgroundColor: "rgba(0,0,0,0.12)"
        }
      };
    };
    return (
        // outer box container for padding around content
        //<Box p={4}>
        <div
            style={{
                padding: '20px',
                backgroundColor: '#FFFDF8',
                minHeight: '100vh',  // ensures it covers the full viewport height
                boxSizing: 'border-box', // ensures padding doesn't affect layout
            }}
        >

            <div style={{ width: '200px' }}></div>

            {/* Centered Buttons */}
            {/*<Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                gap={2}
                flexWrap="wrap"
                sx={{
                    mt: 4,
                    mb: 4,
                }}
                    >
                    <Button
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => history.push('/page1/a')}
                    >
                        Popular
                    </Button>
                    <Button
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => history.push('/page1/b')}
                    >
                        Following
                    </Button>
                    <Button
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => history.push('/page1/c/subPage1Ca')}
                    >
                        Academia
                    </Button>
                    <Button
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => history.push('/page1/d')}
                    >
                        Topic Threads
                    </Button>
                    <Button
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => history.push('/photos/followingPhotos')}
                    >
                        Photos
                    </Button>
                    <Button
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => history.push('/videos/followingVideos')}
                    >
                        Videos
                    </Button>
             </Box>*/}
             {/* Sticky Navigation */}
              <Box
                sx={{
                  position: "sticky",
                  top: 0,
                  zIndex: 1000,
                  backgroundColor: "#FFFDF8",
                  //borderBottom: "1px solid rgba(0,0,0,0.08)",
                  py: 2
                }}
              >
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                        maxWidth: "100%",
                    }}
                >
                    {/* LEFT — LOGO */}
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            minWidth: 220, // keeps layout stable
                        }}
                    >
                        <Tooltip
                            title="Lady Wisdom"
                            arrow
                            followCursor
                        >
                            <Box
                                component="img"
                                src="/Colloquia_Logo.png"
                                alt="Colloquia Logo"
                                onClick={() => history.push("/home")}
                                sx={{
                                    height: 90,
                                    width: "auto",
                                    borderRadius: "10px", // rounded edges
                                    cursor: "pointer",
                                    objectFit: "contain",
                                }}
                            />
                        </Tooltip>
                    </Box>
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  gap={2}
                  flexWrap="wrap"
                >
                  {navItems.map((item) => (
                    <Button
                      key={item.path}
                      variant="outlined"
                      sx={getButtonStyles(item.path)}
                      onClick={() => history.push(item.path)}
                    >
                      {item.label}
                    </Button>
                  ))}
                </Box>
                <Box sx={{ minWidth: 220 }} />
              </Box>
              </Box>
              <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: 1,
                        mt: 2,
                        mb: 1,
                        flexWrap: "wrap",
                    }}
                >
                    <Button
                        variant={
                            popularMode === "voting-power"
                                ? "contained"
                                : "outlined"
                        }
                        size="small"
                        onClick={() =>
                            setPopularMode("voting-power")
                        }
                        sx={{
                            textTransform: "none",
                            borderRadius: "999px",
                            px: 2,
                            fontWeight:
                                popularMode === "voting-power"
                                    ? 600
                                    : 500,
                        }}
                    >
                        Voting Power
                    </Button>

                    <Button
                        variant={
                            popularMode === "ai"
                                ? "contained"
                                : "outlined"
                        }
                        size="small"
                        onClick={() => setPopularMode("ai")}
                        sx={{
                            textTransform: "none",
                            borderRadius: "999px",
                            px: 2,
                            fontWeight:
                                popularMode === "ai"
                                    ? 600
                                    : 500,
                        }}
                    >
                        AI
                    </Button>
                </Box>
            {/* Heading for section with space below it */}
            {/*<Typography variant="h4" gutterBottom>
                Top 3 Most Upvoted Posts
            </Typography>*/}
            {/* conditional rendering: if no posts available */}
            {loadingPosts ? (
                <Typography
                    sx={{
                        textAlign: "center",
                        mt: 4,
                        color: "text.secondary",
                    }}
                >
                    {popularMode === "ai"
                        ? "AI is analyzing today's posts..."
                        : "Loading popular posts..."}
                </Typography>
            ) : aiError ? (
                <Typography
                    sx={{
                        textAlign: "center",
                        mt: 4,
                        color: "text.secondary",
                    }}
                >
                    {aiError}
                </Typography>
            ) : topPosts.length === 0 ? (
                <Typography
                    sx={{
                        textAlign: "center",
                        mt: 4,
                    }}
                >
                    No Posts Available
                </Typography>
            ) : (
                // if posts are available, iterate through each post and render it
                topPosts.map((post,idx) => (
                    // box for each individual post
                    <Box
                        key={post._id} // unique key for each list item
                        //onClick={() => history.push(`/post/${post._id}/comments`)}
                        onClick={() => history.push(`/post/${post._id}/comments`, { source: "popular" })}
                        p={2} // padding inside box
                        my={2} // vertical margin between posts
                        border="1px solid #ccc" // light grey border
                        borderRadius="8px" // rounded corners
                        sx={{ 
                            position: "relative", 
                            maxWidth: 900, // limit width 
                            mx: "auto", // center horizontally
                            my: 2, // vertical spacing between each post
                            cursor: "pointer",
                            "&:hover": {
                                backgroundColor: "#f9f9f9"
                            }
                        }}
                    >
                        {/* display username of post's author, otherwise unknown */}
                        {/*
                        <Typography variant="subtitle1" fontWeight="bold">
                            @{post.author?.username || "Unknown"}
                        </Typography>
                        */}
                        {/* Top bar: username on left, video call button on right */}
                        {/*<Button
                            onClick={() => joinVideoCall(post._id)}
                            variant="outlined"
                            size="small"
                            sx={{
                                position: "absolute",
                                top: 8,
                                right: 8,
                                zIndex: 1
                            }}
                        >
                            Join Video Call
                        </Button>*/}
                        {/*
                        <Box display="flex" justifyContent="space-between" alignItems="center">
                            <Typography variant="subtitle1" fontWeight="bold">
                                @{post.author?.username || "Unknown"}
                                {post.author?.first_name || "Unknown"}
                            </Typography>

                            <Button
                                variant="outlined"
                                size="small"
                                onClick={() => joinVideoCall(post._id)} // join call function
                            >
                                Join Video Call
                            </Button>
                        </Box>
                        */}

                        {/* display post content */}
                        {/*<Typography>{post.content}</Typography>*/}

                        {/* display formated date and time post was created */}
                        {/*<Typography variant="caption" display="block">
                            {new Date(post.created_at).toLocaleString()}
                        </Typography>*/}

                        {/* display number of votes */}
                        { /*
                        <Typography mt={1} variant="body2">
                            {post.upvoters?.length || 0} upvotes
                        </Typography>
                        */}
                        {/*<Typography mt={1} variant="body2">
                            {post.upvotes ?? 0} upvotes
                        </Typography>*/}
                        <Box display="flex" alignItems="flex-start" gap={1}>
                            <Avatar
                                src={post.author?.profileImageUrl || '/default-avatar.jpg'}
                                alt={`${post.author?.first_name || ''} ${post.author?.last_name || ''}`}
                                onClick={(e) => visitProfile(e, post.author?._id)}
                                sx={{ 
                                    width: 62, 
                                    height: 62,
                                    cursor: "pointer",
                                    "&:hover": {
                                        backgroundColor: "#d9e4f0",
                                    }, 
                                    }}
                            />
                            <Box>
                                <Typography 
                                    variant="subtitle1" 
                                    fontWeight="bold"
                                    onClick={(e) => visitProfile(e, post.author?._id)}
                                    sx={{
                                        cursor: "pointer",
                                        display: "inline-block",
                                        "&:hover": {
                                        textDecoration: "underline",
                                        textDecorationColor: "currentColor", 
                                        textUnderlineOffset: "3px",
                                        },
                                    }}
                                >
                                {post.author?.first_name && post.author?.last_name
                                    ? `${post.author.first_name} ${post.author.last_name}`
                                    : 'Unknown Name'}
                                </Typography>
                                <Typography 
                                    variant="body2" 
                                    color="text.secondary"
                                    onClick={(e) => visitProfile(e, post.author?._id)}
                                    sx={{
                                        cursor: "pointer",
                                        display: "block",
                                        "&:hover": {
                                        textDecoration: "underline",
                                        textDecorationColor: "#currentColor",
                                        textUnderlineOffset: "3px",
                                        },
                                    }}
                                >
                                @{post.author?.username || 'unknown'}
                                </Typography>

                                {/* Post content */}
                                <Typography variant="body1" sx={{ mt: 1, whiteSpace: "pre-line" }}>
                                    {post.content}
                                </Typography>

                                {/* Date */}
                                <Typography
                                    variant="caption"
                                    color="text.secondary"
                                    sx={{ display: "block", mt: 0.5 }}
                                >
                                    {`${new Date(post.created_at).toLocaleString()}, ${
                                        post.commentCount
                                    } ${post.commentCount === 1 ? "reply" : "replies"}`}
                                </Typography>

                            </Box>
                        </Box>
        
                        {/* allow user to upvote popular posts that they have not yet upvoted */}
                        {/*
                        <Button
                            variant={post.voted ? "contained" : "outlined"}
                            size="small"
                            onClick={() => toggleVote(post._id)}
                            sx={{ mt: 1 }}
                        >
                            {post.voted ? "Unvote" : "Upvote"}
                        </Button>
                        */}
                        {/*<Box mt={2} display="flex" alignItems="center" gap={1}>
                            <Button
                                size="small"
                                variant={post.voted ? "contained" : "outlined"}
                                onClick={() => toggleVote(post._id)}
                            >
                                ▲ {post.voted ? "Unvote" : "Upvote"}
                            </Button>
                            <Typography variant="body2">{post.upvotes} upvotes</Typography>
                        </Box>*/}
                        <Box mt={2} display="flex" alignItems="center" gap={1}>
                        {post.voted ? (
                            <Box
                               sx={{
                                   position: "relative",
                                   display: "inline-flex",
                                   alignItems: "center",
                                   "&:hover .voted-btn": {
                                       opacity: 0,
                                   },
                                   "&:hover .undo-btn": {
                                       opacity: 1,
                                       pointerEvents: "auto",
                                   },
                               }}
                           >
                                <Button
 					                size="small"
                                    className="voted-btn"
                                    variant="contained"
                                    color="success"
                                    disabled
                                    sx={{
                                       transition: "opacity 0.2s ease",
                                    }}
                                >
                                   Power Voted
                               </Button>
                               <Button
                                    size="small"
                                    className="undo-btn"
                                    variant="contained"
                                    color="error"
                                    sx={{
                                       inset: 0,
                                       position: "absolute",
                                       transition: "opacity 0.2s ease",
                                       opacity: 0,
                                       pointerEvents: "none",
                                   }}
                                   onClick={(e) => {
                                       e.stopPropagation();
                                       toggleVote(post._id)
                                   }}
                               >
                                    Undo
                               </Button>
                           </Box>
                        ) : (
                            <Button
                                size="small"
                                variant="outlined"
                                onClick={(e) => {
                                e.stopPropagation();
                                toggleVote(post._id)}
                            }
                            >
                                ▲ Power Vote
                            </Button>
                        )}
                        <Typography variant="body2">{post.upvotes} Power Votes</Typography>
                   </Box>

                        {/** add comment to popular post */}
                        {/*<Box mt={2}>
                            <input 
                                type="text" // basic text input
                                placeholder="Add a comment" // grey placeholder text before typing
                                value={post.newComment || ""} // controlled component: binds input value to post.newComment

                                onChange={(e) => {
                                    // when user types, update 'newComment' field for the correct post
                                    setTopPosts(prev =>
                                        prev.map(p =>
                                            // if post is being edited, return a new object with updated newComment
                                            p._id === post._id ? { ...p, newComment: e.target.value } : p
                                        )
                                    );
                                }}
                                // basic styling
                                style={{ width: "100%", padding: "6px", marginBottom: "8px" }}
                            />
                            <Button
                                size="small" // small sized button
                                variant="outlined" // outlined button style (not filled)
                                onClick={() => handleAddComment(post._id, post.newComment)} // calls handler with current post id and comment text
                            >
                                Submit Comment
                            </Button>
                        </Box>*/}

                        {/** comment section */}
                        {/*{post.comments?.length > 0 && (
                            <Box mt={2} ml={1}>
                                <Typography variant="body2" fontWeight="bold">Comments:</Typography>
                                {post.comments.map((comment, i) => (
                                    <Box key={i} ml={2} mt={1}>
                                        <Typography variant="body2">
                                            <strong>@{comment.author?.username || "Anonymous"}:</strong> {comment.text}
                                        </Typography>
                                    </Box>
                                ))}
                            </Box>
                        )}*/}

                        {/** view comment button */}
                        {/*<Button
                            variant="outlined"
                            size="small"
                            onClick={() => history.push(`/post/${post._id}/comments`)}
                            sx={{ mt: 1 }}
                        >
                            View Comments
                        </Button>*/}
                    </Box>
                ))
            )}

        </div>
    );
}

export default Page1SubPageA;